"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var hooks_1 = require("../../hooks");
var LinkButton_1 = __importDefault(require("../Button/LinkButton"));
var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
var ConfigProvider_1 = require("../../providers/ConfigProvider");
var either_1 = require("../../utils/either");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  justify-self: flex-end;\n  border-left: 1px solid #3077b7;\n  width: 300px;\n  height: 100%;\n  position: relative;\n"], ["\n  justify-self: flex-end;\n  border-left: 1px solid #3077b7;\n  width: 300px;\n  height: 100%;\n  position: relative;\n"])));
var UserInfo = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: ", ";\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 14px 0 0 30px;\n  user-select: none;\n  height: ", ";\n  color: #ffffff;\n"], ["\n  display: flex;\n  align-items: ", ";\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 14px 0 0 30px;\n  user-select: none;\n  height: ", ";\n  color: #ffffff;\n"])), function (props) { return !props.isMobileMode && 'center'; }, function (props) { return !props.isMobileMode && '100%'; });
var Name = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 3px;\n  max-width: 220px;\n  line-height: 21px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n"], ["\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 3px;\n  max-width: 220px;\n  line-height: 21px;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n"])));
var EntityName = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: 220px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 120%;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n  color: #686868;\n  background-color: #ffffff;\n  border-radius: 10px;\n"], ["\n  max-width: 220px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 120%;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n  color: #686868;\n  background-color: #ffffff;\n  border-radius: 10px;\n"])));
var Mandat = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  margin-bottom: 3px;\n"], ["\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  margin-bottom: 3px;\n"])));
var Overlay = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 100;\n  padding-top: 15px;\n  width: 100%;\n  background: #2362a2;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n"], ["\n  position: absolute;\n  z-index: 100;\n  padding-top: 15px;\n  width: 100%;\n  background: #2362a2;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n"])));
var OverlayMenu = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  & {\n    border-top: 1px solid #d1dbe3;\n    margin-top: 10px;\n    padding: 15px 20px;\n  }\n"], ["\n  & {\n    border-top: 1px solid #d1dbe3;\n    margin-top: 10px;\n    padding: 15px 20px;\n  }\n"])));
var SLinkButton = styled_components_1.default(LinkButton_1.default)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  color: #ffffff;\n"], ["\n  color: #ffffff;\n"])));
var User = function (_a) {
    var name = _a.name, entityName = _a.entityName, userMandat = _a.userMandat, onLogoutClick = _a.onLogoutClick, entityType = _a.entityType, entityId = _a.entityId, isMobileMode = _a.isMobileMode, roleNames = _a.roleNames;
    var isOpen = hooks_1.useBoolean();
    var ref = hooks_1.useClickOutside(isOpen.setFalse).ref;
    var isSwitchMandate = localStorage.getItem('switchMandateEnable') === 'true';
    var _b = hooks_1.useToken(), setRefreshToken = _b.setRefreshToken, setToken = _b.setToken;
    var token = hooks_1.useToken();
    var mandatId = ((token === null || token === void 0 ? void 0 : token.getDataFromToken()) || {}).mandatId;
    var authUrl = ConfigProvider_1.useConfig().authUrl;
    var getMandaty = hooks_1.useGetJSON(authUrl + "/MandatyUzivatele");
    var postMandatLogin = hooks_1.usePostJSON(authUrl + "/MandatLogin");
    var _c = react_1.useState([]), mandaty = _c[0], setMandaty = _c[1];
    react_1.useEffect(function () {
        if (isOpen.value && mandaty.length === 0) {
            var fetchMandaty = function () { return __awaiter(void 0, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getMandaty()];
                        case 1:
                            result = _a.sent();
                            if (either_1.isRight(result)) {
                                setMandaty(result.value);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchMandaty();
        }
    }, [isOpen.value]);
    var handleMandateSelect = function (mandat) { return __awaiter(void 0, void 0, void 0, function () {
        var refreshTokenStored, body, result, _a, newToken, refreshToken, valid;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    refreshTokenStored = localStorage.getItem('refreshToken');
                    if (!refreshTokenStored) {
                        console.error("Refresh token nebyl nalezen v localStorage");
                        return [2 /*return*/];
                    }
                    body = {
                        mandatId: Number(mandat.id),
                        token: refreshTokenStored,
                    };
                    return [4 /*yield*/, postMandatLogin(body)];
                case 1:
                    result = _b.sent();
                    if (either_1.isRight(result)) {
                        _a = result.value, newToken = _a.jwtToken, refreshToken = _a.refreshToken, valid = _a.valid;
                        if (valid && newToken && refreshToken) {
                            setRefreshToken(refreshToken);
                            setToken(newToken);
                            localStorage.setItem('selectedMandateId', mandat.id);
                            window.location.reload();
                        }
                        else {
                            console.error("Neplatná odpověď při přepnutí mandátu.");
                        }
                    }
                    else {
                        console.error('Chyba při volání MandatLogin:', result.value.message || result.value.status);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var entityLink;
    if (entityType && entityId) {
        entityLink = "/" + entityType + "/detail/" + entityId;
    }
    var renderUserInfo = (react_1.default.createElement(UserInfo, { onClick: isOpen.toggle, isMobileMode: isMobileMode },
        react_1.default.createElement("div", null,
            react_1.default.createElement(Tooltip_1.default, { content: name, position: "bottom center" },
                react_1.default.createElement(Name, null, name)),
            react_1.default.createElement(Mandat, null, userMandat),
            roleNames ? (react_1.default.createElement(EntityName, null, roleNames)) : (react_1.default.createElement(Tooltip_1.default, { content: entityName, position: "bottom center" },
                react_1.default.createElement("div", null, entityLink ? (react_1.default.createElement("a", { href: entityLink },
                    react_1.default.createElement(EntityName, null, entityName))) : (react_1.default.createElement(EntityName, null, entityName)))))),
        isOpen.value ? (react_1.default.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", height: "1.7em", transform: "scale(-1 -1)" },
            react_1.default.createElement("polygon", { fill: "currentColor", points: "15.6,8.9 17,10.3 11.8,15.5 6.6,10.3 8,8.9 11.8,12.7 " }))) : (react_1.default.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", height: "1.7em" },
            react_1.default.createElement("polygon", { fill: "currentColor", points: "15.6,8.9 17,10.3 11.8,15.5 6.6,10.3 8,8.9 11.8,12.7 " })))));
    return (react_1.default.createElement(Container, { ref: ref },
        !isOpen.value && renderUserInfo,
        isOpen.value && (react_1.default.createElement(Overlay, null,
            renderUserInfo,
            react_1.default.createElement(OverlayMenu, null,
                isSwitchMandate && (react_1.default.createElement("div", { style: { marginBottom: 10 } }, (mandaty || []).map(function (m) { return (react_1.default.createElement(SLinkButton, { key: m.id, onClick: function () { return handleMandateSelect(m); }, style: {
                        fontWeight: m.id === mandatId ? 'bold' : 'normal',
                        backgroundColor: m.id === mandatId ? '#1b4e80' : 'transparent',
                    } },
                    m.name,
                    m.id === mandatId && ' (aktuální)')); }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(SLinkButton, { onClick: onLogoutClick }, "Odhl\u00E1sit")))))));
};
User.defaultProps = {
    name: undefined,
    entityName: undefined,
    userMandat: undefined,
    onLogoutClick: undefined,
    entityType: undefined,
    entityId: undefined,
    isMobileMode: undefined,
    roleNames: undefined,
};
exports.default = User;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
